module.exports = __webpack_public_path__ + "static/media/boat.cf512dca.jpg";